import React, {useState, useEffect} from "react";
import { ChoixPeriodeLayout } from "../shared/ChoixPeriodeLayout";

export const ChoixPeriodeCesu = () => {
const PRESTATION_NAME="cesu";
  return (
    <ChoixPeriodeLayout prestationName={PRESTATION_NAME}/>
  );
};
